import FJActionConstant from '../../constant/FJActionConstant'
import FJCanvasStore from "../../store/FJCanvasStore";
import FJTimelineStore from "fj-timeline";
import _ from 'lodash';
import {FJMediaAction, FJModalAction, FJPreviewAction, FJToolbarAction} from "./FJRoot.action";
// import FJEvent from "../../core/FJEvent";
import FJConfig from "../../config/FJConfig";
import FJLocalStore from "../../store/FJLocalStore";
import FJUtil from "../../util/FJUtil";
import key from 'keymaster';
import FJEventConstant from "../../constant/FJEventConstant";
import FJCoreUtil from "../../core/util/FJCoreUtil";
import FJPaymentAction from "./FJPayment.action";

let FJTimeLineAction = (function () {

  let throttleTimelineTool = null;
  let currentTimeLineHeight = 0;

  /**
   * @description 设置当前用户的 显示时间轴时长超过60min的弹窗的 localStorage
   * @param boolean
   */
  let setTimeLimitStorage = function (boolean) {
    let timeLimitObj = localStorage.getItem('timeLimitObj');
    let uid = FJUtil.getUerId();
    if (timeLimitObj) {
      let obj = JSON.parse(timeLimitObj);
      obj[uid] = boolean;
      localStorage.setItem('timeLimitObj', JSON.stringify(obj))
    } else {
      let obj = {};
      obj[uid] = boolean;
      localStorage.setItem('timeLimitObj', JSON.stringify(obj));
    }
  };

  return {

    /**
     * @description 选中某个时间线
     * @param id
     * @return {Function}
     */
    selectTimeLineAction: function (id) {
      return (dispatch) => {
        let {SELECT_ITEM} = FJCanvasStore.command;
        let selectedGraph =  FJCanvasStore.executeSync(SELECT_ITEM, id);

        // 传入的id可能是子元素，selectedGraph是父元素
        dispatch(this.updateTimeLineSelectionAction(selectedGraph ? selectedGraph.id : -1));
        dispatch(FJTimeLineAction.updateCopyStatusAction());
        dispatch(FJTimeLineAction.updateSplitStatusAction());
      };
    },

    /**
     * @description 拖动某个时间线
     * @param id
     * @param data
     * @param {number} data.dragMode
     * @param {string} data.eventType
     * @param {Object} data.cursorPoint
     * @param {Object} data.cursorOffset
     * @param {Object} data.selfRect
     * @param {Object} data.mainTrackRect
     * @param {boolean} data.isNew
     * @param {array} data.boundingClientRects
     * @return {Function}
     */
    dragTimeLineAction: function (id, data) {
      return async (dispatch) => {
        if (data.eventType === 'start' || data.eventType === 'change') {
          key.setScope('');
        }
        dispatch(FJPreviewAction.setVideoPauseAction());
        let adsorptionLineTimes = FJCanvasStore.executeSync(FJCanvasStore.command.DRAG_TIMELINE, id, data);
        if (adsorptionLineTimes) {

          // 异步的目的是将时间线的界面置于下一个事件循环，避免当前Task执行时间过长
          // TODO 移出这里的异步处理，不过需要将时间线组件拆分为多个平级的组件，避免内部在update阶段执行过长时间
          setTimeout(() => {
            dispatch(this.updateCoverEleStatusAction(adsorptionLineTimes.isCoverEle));
            dispatch(this.updateAllTimelineAction(data.eventType === 'end'));
          }, 0);

          if (adsorptionLineTimes.adsorptionLine) {
            dispatch(this.setTimelineAdsorptionAction(adsorptionLineTimes.adsorptionLine.map(lineTime => FJTimelineStore.timeToPixel(lineTime))));
          }
        }

        if (data.eventType === 'end') {
          key.setScope('default');
          window.FJEvent.dispatch(FJActionConstant.EVENT_TIMELINE_LAYOUT);
          dispatch(this.checkIsShowTimeLimitModalAction());

          // TODO 删除wait
          // 去掉wait后，在拖动结束时video标签会触发error，暂时没有找到原因
          await FJCoreUtil.wait(100);
          await FJCanvasStore.execute(FJCanvasStore.command.RE_SEEK_AND_RENDER);

          dispatch(this.updateCopyStatusAction());
          dispatch(this.updatePasteStatusAction());
          dispatch(this.updateSplitStatusAction());
          dispatch(FJToolbarAction.updateToolbarAction());
        }
      };
    },

    /**
     * @description 更新某个时间线的选中状态
     * @param id
     * @return {{id: *, type: string}}
     */
    updateTimeLineSelectionAction: function (id) {
      return {
        type: FJActionConstant.UPDATE_TIMELINE_SELECTION,
        id,
      }
    },

    /**
     * @description 更新所有时间线的布局信息
     * @param {boolean} flush 是否立即更新时间线宽高布局
     * @return {Function}
     */
    updateAllTimelineAction: function (flush=true) {
      return (dispatch, getState) => {
        let {GET_ALL_TRACK_DATA, GET_MAIN_LAYER_VOLUME} = FJCanvasStore.command;
        let data = FJCanvasStore.executeSync(GET_ALL_TRACK_DATA);
        dispatch(this.updateAllTimelineBrickAction(data));
        dispatch(this.updatePreviewDurationAction(data)); // 更新预览时间轴的总时长（在变化）
        dispatch(FJPaymentAction.updateLimitsAction());

        if (flush) {
          window.FJEvent.dispatch(FJActionConstant.EVENT_TIMELINE_LAYOUT);
        }

        const state = getState();
        const timeline = state.timeline;
        if (flush && timeline.currentTime > FJCanvasStore.executeSync(FJCanvasStore.command.GET_ALL_DURATION)) {
          dispatch(FJPreviewAction.setVideoProcessAction('change', 1, {isPercent: true, flush: true, useThrottle: false}));
          dispatch(FJTimeLineAction.updateSplitStatusAction());
        }

        dispatch(this.setMainLayerVolumeAction(FJCanvasStore.executeSync(GET_MAIN_LAYER_VOLUME)));
      };
    },

    /**
     * @description 更新所有时间线对象的brick的信息
     * @param data
     * @return {{data: *, type: string}}
     */
    updateAllTimelineBrickAction: function (data) {
      return {
        type: FJActionConstant.UPDATE_ALL_TIMELINE_BRICK,
        data,
      }
    },

    /**
     * @description 更新时长 （end后更新， 也叫拖动结束后）
     * @return {{duration, type: string}}
     */
    updateDurationAction: function () {
      let duration = FJCanvasStore.executeSync(FJCanvasStore.command.GET_ALL_DURATION);
      return {
        type: FJActionConstant.UPDATE_DURATION,
        duration,
      }
    },

    /**
     * @description 更新在change过程中的总时长值（一直在变化， 也叫拖动过程中）
     * @returns {{data, type: string}}
     */
    updatePreviewDurationAction: function () {
      let duration = FJCanvasStore.executeSync(FJCanvasStore.command.GET_ALL_DURATION);
      return {
        type: FJActionConstant.UPDATE_REAL_DURATION,
        data: duration
      }
    },

    /**
     * @description 滑动时间轴操作栏的时间轴缩放放大的进度条
     * @param type
     * @param currentUnitConversion
     * @returns {Function}
     */
    changeUnitConversionAction: function (type, currentUnitConversion) {
      return (dispatch) => {

        throttleTimelineTool = throttleTimelineTool || _.throttle((currentUnitConversion) => {
          dispatch(this.setTimelineUnitConversionAction(currentUnitConversion));
          FJUtil.ealog('timeline_timeline zoom use');
        }, 300);

        switch (type) {
          case 'change':
            throttleTimelineTool(currentUnitConversion);
            break;
          case 'end':
            throttleTimelineTool.cancel();
            throttleTimelineTool.flush(currentUnitConversion);
            dispatch(this.setTimelineUnitConversionAction(currentUnitConversion));
            break;
          default:
        }

      }
    },

    /**
     * @description 设置时间轴 单位转换的值
     * @param data 时间轴 单位转换的值
     * @returns {Function}
     */
    setTimelineUnitConversionAction: function (data) {
      return (dispatch) => {
        FJTimelineStore.setUnitConversion(data);
        dispatch(this.updateAllTimelineAction());
        window.FJEvent.dispatch(FJActionConstant.EVENT_UNIT_CONVERSION_CHANGE);
        dispatch({
          type: FJActionConstant.UPDATE_UNIT_CONVERSION,
          data
        })
      }
    },

    /**
     * @description 设置是否拖动资源到时间轴拖动
     * @param bool {boolean}
     * @returns {{data: *, type: string}}
     */
    setDraggingStateAction: function (bool) {
      return {
        type: FJActionConstant.SET_DRAGGING_STATE,
        data: bool,
      }
    },

    /**
     * @description 删除元素
     * @param id
     * @param isInvalidUndo
     * @return {Function}
     */
    deleteTimelineAction: function (id, isInvalidUndo) {
      return (dispatch) => {
        dispatch(FJPreviewAction.setVideoPauseAction());
        FJCanvasStore.executeSync(FJCanvasStore.command.DELETE_GRAPHS_BY_ID, id, isInvalidUndo);
        dispatch(FJTimeLineAction.selectTimeLineAction(-1)); // 选中
        dispatch(FJTimeLineAction.updateAllTimelineAction());
        dispatch(FJTimeLineAction.updateCopyStatusAction());
        dispatch(FJTimeLineAction.updatePasteStatusAction());
        dispatch(FJTimeLineAction.updateSplitStatusAction());
        dispatch(FJToolbarAction.updateToolbarAction());
        FJCanvasStore.execute(FJCanvasStore.command.RE_SEEK_AND_RENDER);
      }
    },

    /**
     * @description 切割时间线
     * @param id
     */
    splitTimelineAction: function (id) {
      return (dispatch) => {
        dispatch(FJPreviewAction.setVideoPauseAction());
        let result = FJCanvasStore.executeSync(FJCanvasStore.command.SPLIT_TIMELINE, id);
        if (result) {
          dispatch(this.updateTimeLineSelectionAction(-1));
          dispatch(FJTimeLineAction.updateCopyStatusAction());
          dispatch(FJTimeLineAction.updatePasteStatusAction());
          dispatch(FJTimeLineAction.updateSplitStatusAction());
        }
        dispatch(this.updateAllTimelineAction());
        dispatch(FJToolbarAction.updateToolbarAction());

        FJUtil.ealog('timeline_split click');
      };
    },

    /**
     * @description 改变时间轴区域占 body高度（除去header）的比列
     * @param type
     * @param value
     * @returns {Function}
     */
    changeTimeLineHeightRadio: function (type, value) {
      return (dispatch, getState) => {
        let realClientHeight = document.body.clientHeight - 60;
        let MaxHeight = Math.floor(realClientHeight * FJConfig.timeLineMaxRatio);
        let MinHeight = Math.floor(realClientHeight * FJConfig.timeLineMinRatio);
        let radio;

        switch (type) {
          case 'start': {
            const state = getState();
            const timeline = state.timeline;
            currentTimeLineHeight = Math.floor(realClientHeight * timeline.timeLineHeightRadio);
            break;
          }
          case 'change':
            if (currentTimeLineHeight + value >= MinHeight && currentTimeLineHeight + value <= MaxHeight) {
              radio = (currentTimeLineHeight + value) / realClientHeight;
              dispatch(this.setTimeLineHeightRadioAction(radio));
              window.FJEvent.dispatch(FJEventConstant.UPDATE_TIMELINE_HEIGHT);
            }
            break;
          case 'end':
            currentTimeLineHeight = 0;
            break;
          default:
        }
      }
    },

    /**
     * @description 时间轴区域占 body高度（除去header）的比列
     * @param radio
     * @returns {{data: *, type: string}}
     */
    setTimeLineHeightRadioAction: function (radio) {
      return {
        type: FJActionConstant.SET_TIME_LINE_HEIGHT_RADIO,
        data: radio
      }
    },

    /**
     * @description 设置时间线吸附线参数
     * @param value
     * @return {{type: string, value: *}}
     */
    setTimelineAdsorptionAction: function (value) {
      return (dispatch, getState) => {
        let preValues = getState().timeline.adsorptionLineHorizontalValues;
        if (value.toString() !== preValues.toString()) {
          dispatch({
            type: FJActionConstant.SET_TIMELINE_ADSORPTION,
            value,
          });
        }
      }
    },

    /**
     * @description 判断是否需要显示显示时间轴时长超过限制的弹窗
     * @returns {Function}
     */
    checkIsShowTimeLimitModalAction: function () {
      return (dispatch, getState) => {
        const state = getState();
        const timeline = state.timeline;
        if (timeline.realDuration > FJConfig.maxLimitTime) {
          let timeLimitObj = localStorage.getItem('timeLimitObj');
          if (timeLimitObj) {
            let useTimeLimitObj = JSON.parse(timeLimitObj);
            let uid = FJUtil.getUerId();
            if (useTimeLimitObj[uid] !== true) {
              dispatch(this.showBeyondTimeLimitModal());
              setTimeLimitStorage(true);
            }
          } else {
            dispatch(this.showBeyondTimeLimitModal());
            setTimeLimitStorage(true);
          }
        }
      }
    },

    /**
     * @description 显示时间轴时长超过60min的弹窗
     * @returns {Function}
     */
    showBeyondTimeLimitModal: function () {
      return (dispatch) => {
        let data = {
          headerText: FJLocalStore._('beyond-time-limit'),
          bodyText: FJLocalStore._('beyond-time-limit-content').replace('xxx', FJConfig.maxLimitTime / 60),
          cancelType: 'cancel',
          hasCancel: false,
          submitText: FJLocalStore._('got-it')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      }
    },

    /**
     * @description 复制
     * @param selectedId
     */
    copyAction: function (selectedId) {
      return (dispatch, getState) => {
        if (getState().copy.couldCopy) {
          FJCanvasStore.executeSync(FJCanvasStore.command.COPY, selectedId);
          dispatch(this.updatePasteStatusAction());
        }
      };
    },

    /**
     * @description 粘贴
     */
    pasteAction: function () {
      return (dispatch, getState) => {
        if (getState().copy.couldPaste) {
          let {
            PASTE,
            RE_SEEK_AND_RENDER,
          } = FJCanvasStore.command;
          let graphId = FJCanvasStore.executeSync(PASTE);
          if (graphId) {
            dispatch(FJPreviewAction.setVideoPauseAction());
            dispatch(FJTimeLineAction.updateAllTimelineAction());
            dispatch(FJTimeLineAction.updateDurationAction());
            dispatch(FJTimeLineAction.selectTimeLineAction(graphId));
            dispatch(FJMediaAction.jumpToSelectedStartAction(1));
            dispatch(FJToolbarAction.updateToolbarAction());
            dispatch(FJTimeLineAction.updateCopyStatusAction());
            dispatch(FJTimeLineAction.updatePasteStatusAction());
            dispatch(FJTimeLineAction.updateSplitStatusAction());
            dispatch(this.checkIsShowTimeLimitModalAction());
            FJCanvasStore.execute(RE_SEEK_AND_RENDER);
            window.FJEvent.dispatch(FJEventConstant.AUTO_POSITION_SELECTED_TIMELINE);
          }
        }
      };
    },

    /**
     * @description 更新复制按钮状态
     */
    updateCopyStatusAction: function () {
      return (dispatch) => {
        dispatch(this.setCopyStatusAction(FJCanvasStore.executeSync(FJCanvasStore.command.GET_COPY_STATUS)));
      };
    },

    /**
     * @description 更新 Split 按钮状态
     */
    updateSplitStatusAction: function() {
      return (dispatch) => {
        dispatch(this.setSplitStatusAction(FJCanvasStore.executeSync(FJCanvasStore.command.GET_TIMELINE_IS_ELE)));
      };
    },

    /**
     * @description 更新粘贴按钮状态
     */
    updatePasteStatusAction: function () {
      return (dispatch) => {
        dispatch(this.setPasteStatusAction(FJCanvasStore.executeSync(FJCanvasStore.command.GET_PASTE_STATUS)));
      };
    },

    /**
     * @description 设置复制按钮状态
     * @param couldCopy
     * @return {{couldCopy: *, type: string}}
     */
    setCopyStatusAction: function (couldCopy) {
      return {
        type: FJActionConstant.UPDATE_COPY_STATUS,
        couldCopy,
      }
    },

    /**
     * @description 是否有覆盖元素
     * @param couldStatus
     * @returns {{couldStatus: *, type: string}}
     */
    updateCoverEleStatusAction: function (couldStatus) {
      return {
        type: FJActionConstant.UPDATE_COVER_ELE_STATUS,
        couldStatus,
      }
    },

    /**
     * @description 设置 Split 按钮状态
     * @param couldSplit
     * @returns {{couldCopy: *, type: string}}
     */
    setSplitStatusAction: function (couldSplit) {
      return {
        type: FJActionConstant.UPDATE_SPLIT_STATUS,
        couldSplit,
      }
    },

    /**
     * @description 设置粘贴按钮状态
     * @param couldPaste
     * @return {{couldPaste: *, type: string}}
     */
    setPasteStatusAction: function (couldPaste) {
      return {
        type: FJActionConstant.UPDATE_PASTE_STATUS,
        couldPaste,
      }
    },

    /**
     * @description 设置主轴音量
     * @param volume
     */
    changeMainerLayerVolumeAction: function (volume) {
      return (dispatch) => {
        FJUtil.ealog('timeline_adjust_volume', {
          location: 'timeline',
        });
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_MAIN_LAYER_VOLUME, volume);
        dispatch(this.setMainLayerVolumeAction(volume));
      };
    },

    /**
     * @description 更新主轴音量
     * @param volume
     * @return {{volume: *, type: string}}
     */
    setMainLayerVolumeAction: function (volume) {
      return {
        type: FJActionConstant.SET_MAIN_LAYER_VOLUME,
        volume,
      }
    },

    /**
     * @description 删除转场
     * @param id
     */
    deleteTransitionAction: function (id) {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.DELETE_TRANSITION, id);
        dispatch(this.updateAllTimelineAction(true));
        dispatch(FJToolbarAction.updateToolbarAction());
      }
    },

    /**
     * @description 设置转场时长
     * @param id
     * @param duration
     */
    changeTransitionDurationAction: function (id, duration) {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.UPDATE_TRANSITION, id, {duration});
        dispatch(this.updateAllTimelineAction(true));
        dispatch(FJToolbarAction.updateToolbarAction());
      };
    }
  }
})();

export default FJTimeLineAction;
